import { render, staticRenderFns } from "./CustomerAttraction.vue?vue&type=template&id=e9192e74&scoped=true&"
import script from "./CustomerAttraction.vue?vue&type=script&lang=js&"
export * from "./CustomerAttraction.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAttraction.vue?vue&type=style&index=0&id=e9192e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9192e74",
  null
  
)

export default component.exports